import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database.types';

// Support both web (Vite) and mobile (Expo) environment variables.
// On web, only `import.meta.env.VITE_*` is replaced at build time; `process.env.*`
// references survive verbatim and read as `undefined` at runtime — which would
// throw inside `createClient`. To keep this module side-effect-free at bundle
// load (web has its own supabase client in src/lib/supabase.ts and doesn't use
// this one), fall back to a placeholder URL that satisfies the SDK's input
// validation. Any consumer that actually tries to make a request without
// env vars set will fail at the network layer, which is the correct behavior.
const supabaseUrl =
  (typeof process !== 'undefined' &&
    (process.env.EXPO_PUBLIC_SUPABASE_URL || process.env.VITE_SUPABASE_URL)) ||
  '';

const supabaseAnonKey =
  (typeof process !== 'undefined' &&
    (process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY)) ||
  '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Missing Supabase environment variables. Client may not function properly.');
}

export const supabase = createClient<Database>(
  supabaseUrl || 'https://placeholder.invalid',
  supabaseAnonKey || 'placeholder',
);